/* script */











import tinycolor from 'tinycolor2';
import { tl } from '../languages';

const __vue_script__ = {
	name: 'color-picker-normal',
	props: {
		width: Number,
		height: Number,
		value: String
	},
	data() {return {
	}},
	computed: {
		position() {
			let color = new tinycolor(this.value);
			let rgb = color.toRgb();
			let square =  {
				x: (rgb.r/255 - 0.5) * 100,
				y: (rgb.g/255 - 0.5) * 100,
			};
			let angle = Math.atan2(square.y, square.x);
			let distance = Math.sqrt(Math.pow(square.x, 2) + Math.pow(square.y, 2));
			distance = Math.clamp(distance, -50, 50);
			return {
				x: (50 + Math.cos(angle) * distance) / 100 * (this.height-10) + 5,
				y: (50 - Math.sin(angle) * distance) / 100 * (this.width-10) + 5,
			}
		}
	},
	methods: {
		pointerDown(e1) {
			let bounding_box = this.$refs.reference.getBoundingClientRect();
			let onMove = (e2) => {
				let snap = e2.ctrlOrCmd ? 1 : 5;
				let x = e2.clientX - bounding_box.x;
				let y = e2.clientY - bounding_box.y;
				x = Math.snapToValues(x, [bounding_box.width/2], snap);
				y = Math.snapToValues(y, [bounding_box.height/2], snap);
				let color = new tinycolor({
					r: (x / (this.width - 10)) * 255,
					g: (1 - y / (this.height - 10)) * 255,
					b: 255
				})
				this.$emit('input', '#'+color.toHex());
			}
			let onUp = (e2) => {
				document.removeEventListener('pointermove', onMove);
				document.removeEventListener('pointerup', onUp);
			}
			document.addEventListener('pointermove', onMove);
			document.addEventListener('pointerup', onUp);
			onMove(e1);
		},
		tl,
	},
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "normal_map_color_picker",
      style: { height: _vm.height + "px" },
      on: {
        pointerdown: function ($event) {
          return _vm.pointerDown($event)
        },
      },
    },
    [
      _c("div", {
        ref: "reference",
        staticClass: "normal_map_color_picker--bg_x",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "normal_map_color_picker--bg_y" }),
      _vm._v(" "),
      _c("div", {
        staticClass: "normal_map_color_picker--cursor",
        style: { left: _vm.position.x + "px", top: _vm.position.y + "px" },
      }),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-b7e74ed8_0", { source: "\n.normal_map_color_picker {\n\tposition: relative;\n\theight: 300px;\n}\n.normal_map_color_picker--bg_x,\n.normal_map_color_picker--bg_y {\n\ttop: 5px;\n\tleft: 5px;\n\theight: calc(100% - 10px);\n\twidth: calc(100% - 10px);\n\tposition: absolute;\n\tpointer-events: none;\n\tborder-radius: 50%;\n}\n.normal_map_color_picker--bg_x {\n\tbackground: linear-gradient(to right, rgb(0, 0, 255), rgb(255, 0, 255));\n}\n.normal_map_color_picker--bg_y {\n\tbackground: linear-gradient(to top, rgb(0, 0, 255), rgb(0, 255, 255));\n\tmix-blend-mode: lighten;\n}\n.normal_map_color_picker--bg_x::before,\n.normal_map_color_picker--bg_x::after {\n\tcontent: \"\";\n\twidth: 2px;\n\theight: 2px;\n\tposition: absolute;\n\tbackground-color: var(--color-light);\n\topacity: 0.2;\n\tz-index: 1;\n}\n.normal_map_color_picker--bg_x::before {\n\twidth: 100%;\n\ttop: calc(50% - 1px);\n\tleft: 0;\n\tright: 0;\n}\n.normal_map_color_picker--bg_x::after {\n\theight: 100%;\n\ttop: 0;\n\tbottom: 0;\n\tleft: calc(50% - 1px);\n}\n.normal_map_color_picker--cursor {\n\tposition: absolute;\n\tborder-radius: 6px;\n\theight: 10px;\n\twidth: 10px;\n\tborder: 1px solid var(--color-border);\n\tbackground: var(--color-light);\n\tcursor: pointer;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 2;\n\tmargin: -5px;\n}\n", map: {"version":3,"sources":["js\\texturing\\ColorPickerNormal.vue"],"names":[],"mappings":";AAsEA;CACA,kBAAA;CACA,aAAA;AACA;AACA;;CAEA,QAAA;CACA,SAAA;CACA,yBAAA;CACA,wBAAA;CACA,kBAAA;CACA,oBAAA;CACA,kBAAA;AACA;AACA;CACA,uEAAA;AACA;AACA;CACA,qEAAA;CACA,uBAAA;AACA;AACA;;CAEA,WAAA;CACA,UAAA;CACA,WAAA;CACA,kBAAA;CACA,oCAAA;CACA,YAAA;CACA,UAAA;AACA;AACA;CACA,WAAA;CACA,oBAAA;CACA,OAAA;CACA,QAAA;AACA;AACA;CACA,YAAA;CACA,MAAA;CACA,SAAA;CACA,qBAAA;AACA;AACA;CACA,kBAAA;CACA,kBAAA;CACA,YAAA;CACA,WAAA;CACA,qCAAA;CACA,8BAAA;CACA,eAAA;CACA,MAAA;CACA,OAAA;CACA,UAAA;CACA,YAAA;AACA","file":"ColorPickerNormal.vue","sourcesContent":["<template>\r\n\t<div class=\"normal_map_color_picker\" :style=\"{height: height + 'px'}\" @pointerdown=\"pointerDown($event)\">\r\n\t\t<div class=\"normal_map_color_picker--bg_x\" ref=\"reference\"></div>\r\n\t\t<div class=\"normal_map_color_picker--bg_y\"></div>\r\n\t\t<div class=\"normal_map_color_picker--cursor\"\r\n\t\t\t:style=\"{left: position.x + 'px', top: position.y + 'px'}\"\r\n\t\t></div>\r\n\t</div>\r\n</template>\r\n\r\n<script lang=\"js\">\r\nimport tinycolor from 'tinycolor2';\r\nimport { tl } from '../languages';\r\n\r\nexport default {\r\n\tname: 'color-picker-normal',\r\n\tprops: {\r\n\t\twidth: Number,\r\n\t\theight: Number,\r\n\t\tvalue: String\r\n\t},\r\n\tdata() {return {\r\n\t}},\r\n\tcomputed: {\r\n\t\tposition() {\r\n\t\t\tlet color = new tinycolor(this.value);\r\n\t\t\tlet rgb = color.toRgb();\r\n\t\t\tlet square =  {\r\n\t\t\t\tx: (rgb.r/255 - 0.5) * 100,\r\n\t\t\t\ty: (rgb.g/255 - 0.5) * 100,\r\n\t\t\t};\r\n\t\t\tlet angle = Math.atan2(square.y, square.x);\r\n\t\t\tlet distance = Math.sqrt(Math.pow(square.x, 2) + Math.pow(square.y, 2));\r\n\t\t\tdistance = Math.clamp(distance, -50, 50);\r\n\t\t\treturn {\r\n\t\t\t\tx: (50 + Math.cos(angle) * distance) / 100 * (this.height-10) + 5,\r\n\t\t\t\ty: (50 - Math.sin(angle) * distance) / 100 * (this.width-10) + 5,\r\n\t\t\t}\r\n\t\t}\r\n\t},\r\n\tmethods: {\r\n\t\tpointerDown(e1) {\r\n\t\t\tlet bounding_box = this.$refs.reference.getBoundingClientRect();\r\n\t\t\tlet onMove = (e2) => {\r\n\t\t\t\tlet snap = e2.ctrlOrCmd ? 1 : 5;\r\n\t\t\t\tlet x = e2.clientX - bounding_box.x;\r\n\t\t\t\tlet y = e2.clientY - bounding_box.y;\r\n\t\t\t\tx = Math.snapToValues(x, [bounding_box.width/2], snap);\r\n\t\t\t\ty = Math.snapToValues(y, [bounding_box.height/2], snap);\r\n\t\t\t\tlet color = new tinycolor({\r\n\t\t\t\t\tr: (x / (this.width - 10)) * 255,\r\n\t\t\t\t\tg: (1 - y / (this.height - 10)) * 255,\r\n\t\t\t\t\tb: 255\r\n\t\t\t\t})\r\n\t\t\t\tthis.$emit('input', '#'+color.toHex());\r\n\t\t\t}\r\n\t\t\tlet onUp = (e2) => {\r\n\t\t\t\tdocument.removeEventListener('pointermove', onMove);\r\n\t\t\t\tdocument.removeEventListener('pointerup', onUp);\r\n\t\t\t}\r\n\t\t\tdocument.addEventListener('pointermove', onMove);\r\n\t\t\tdocument.addEventListener('pointerup', onUp);\r\n\t\t\tonMove(e1);\r\n\t\t},\r\n\t\ttl,\r\n\t},\r\n}\r\n</script>\r\n\r\n<style>\r\n\t.normal_map_color_picker {\r\n\t\tposition: relative;\r\n\t\theight: 300px;\r\n\t}\r\n\t.normal_map_color_picker--bg_x,\r\n\t.normal_map_color_picker--bg_y {\r\n\t\ttop: 5px;\r\n\t\tleft: 5px;\r\n\t\theight: calc(100% - 10px);\r\n\t\twidth: calc(100% - 10px);\r\n\t\tposition: absolute;\r\n\t\tpointer-events: none;\r\n\t\tborder-radius: 50%;\r\n\t}\r\n\t.normal_map_color_picker--bg_x {\r\n\t\tbackground: linear-gradient(to right, rgb(0, 0, 255), rgb(255, 0, 255));\r\n\t}\r\n\t.normal_map_color_picker--bg_y {\r\n\t\tbackground: linear-gradient(to top, rgb(0, 0, 255), rgb(0, 255, 255));\r\n\t\tmix-blend-mode: lighten;\r\n\t}\r\n\t.normal_map_color_picker--bg_x::before,\r\n\t.normal_map_color_picker--bg_x::after {\r\n\t\tcontent: \"\";\r\n\t\twidth: 2px;\r\n\t\theight: 2px;\r\n\t\tposition: absolute;\r\n\t\tbackground-color: var(--color-light);\r\n\t\topacity: 0.2;\r\n\t\tz-index: 1;\r\n\t}\r\n\t.normal_map_color_picker--bg_x::before {\r\n\t\twidth: 100%;\r\n\t\ttop: calc(50% - 1px);\r\n\t\tleft: 0;\r\n\t\tright: 0;\r\n\t}\r\n\t.normal_map_color_picker--bg_x::after {\r\n\t\theight: 100%;\r\n\t\ttop: 0;\r\n\t\tbottom: 0;\r\n\t\tleft: calc(50% - 1px);\r\n\t}\r\n\t.normal_map_color_picker--cursor {\r\n\t\tposition: absolute;\r\n\t\tborder-radius: 6px;\r\n\t\theight: 10px;\r\n\t\twidth: 10px;\r\n\t\tborder: 1px solid var(--color-border);\r\n\t\tbackground: var(--color-light);\r\n\t\tcursor: pointer;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tz-index: 2;\r\n\t\tmargin: -5px;\r\n\t}\r\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "js\\texturing\\ColorPickerNormal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__